import { Overlay, OverlayRef } from "@angular/cdk/overlay";
import { ComponentPortal } from "@angular/cdk/portal";
import { Injectable, Injector } from "@angular/core";

import { KontaktoplysningerPopupContentComponent } from "./kontaktoplysninger-popup-content/kontaktoplysninger-popup-content.component";
import { KontaktoplysningerPopupRef } from "./kontaktoplysninger-popup-ref";

@Injectable({ providedIn: "root" })
export class KontaktoplysningerPopup {
    public popupRef: KontaktoplysningerPopupRef;
    constructor(private readonly injector: Injector, private readonly overlay: Overlay) {}

    public open(): KontaktoplysningerPopupRef {
        if (this.popupRef) {
            return this.popupRef;
        }
        const overlayRef = this.overlay.create({
            positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically(),
            hasBackdrop: true,
            backdropClass: "kontaktoplysninger-popup-backdrop",
            scrollStrategy: this.overlay.scrollStrategies.block()
        });
        this.popupRef = new KontaktoplysningerPopupRef(overlayRef);
        this.popupRef.closed.subscribe(() => {
            this.popupRef = null;
        });
        this.popupRef.canceled.subscribe(() => {
            this.popupRef = null;
        });
        this.attachContainer(overlayRef, this.popupRef);

        return this.popupRef;
    }

    private attachContainer(overlayRef: OverlayRef, popupRef: KontaktoplysningerPopupRef): KontaktoplysningerPopupContentComponent {
        const injector = this.createInjector(popupRef);
        const containerPortal = new ComponentPortal(KontaktoplysningerPopupContentComponent, null, injector);
        const containerRef = overlayRef.attach(containerPortal);
        return containerRef.instance;
    }

    private createInjector(popupRef: KontaktoplysningerPopupRef): Injector {
        return Injector.create({
            parent: this.injector,
            providers: [
                {
                    provide: KontaktoplysningerPopupRef,
                    useValue: popupRef
                }
            ]
        });
    }
}
